export var PlatformName;
(function (PlatformName) {
    PlatformName["linux"] = "linux";
    PlatformName["mac"] = "mac";
    PlatformName["windows"] = "windows";
})(PlatformName || (PlatformName = {}));
export var PackageManager;
(function (PackageManager) {
    PackageManager["bun"] = "bun";
    PackageManager["npm"] = "npm";
    PackageManager["pnpm"] = "pnpm";
    PackageManager["yarn"] = "yarn";
})(PackageManager || (PackageManager = {}));
export var BuildStatus;
(function (BuildStatus) {
    BuildStatus["building"] = "building";
    BuildStatus["cancelled"] = "cancelled";
    BuildStatus["failed"] = "failed";
    BuildStatus["preparation"] = "preparation";
    BuildStatus["queued"] = "queued";
    BuildStatus["succeeded"] = "succeeded";
})(BuildStatus || (BuildStatus = {}));
export var AnalysisStatus;
(function (AnalysisStatus) {
    AnalysisStatus["analyzing"] = "analyzing";
    AnalysisStatus["done"] = "done";
    AnalysisStatus["downloading"] = "downloading";
    AnalysisStatus["error"] = "error";
    AnalysisStatus["extracting"] = "extracting";
    AnalysisStatus["initializing"] = "initializing";
    AnalysisStatus["notStarted"] = "notStarted";
})(AnalysisStatus || (AnalysisStatus = {}));
export var ManifestCategory;
(function (ManifestCategory) {
    ManifestCategory["buildStamped"] = "build-stamped";
    ManifestCategory["primary"] = "primary";
    ManifestCategory["versioned"] = "versioned";
})(ManifestCategory || (ManifestCategory = {}));
export const hasBuildKickedOff = (build) => {
    if (!build) {
        return false;
    }
    return build.status && build.status !== BuildStatus.preparation;
};
export const isPlatformBuildRunning = (platformBuild) => {
    if (!platformBuild) {
        return false;
    }
    return (!platformBuild.shouldSkip && // <-- Noteworthy
        !['cancelled', 'succeeded'].includes(platformBuild.status) &&
        (platformBuild.status !== 'failed' ||
            platformBuild.numberOfAttemptedBuilds < 2));
};
// NOTE: this relies on Firestore solely
export const isCiBuildRunning = (build) => {
    if (!build) {
        return false;
    }
    return (build.status === 'building' ||
        (build.status === 'failed' &&
            ['linux', 'mac', 'windows'].some((platform) => build.status === 'building' ||
                (build.status === 'failed' &&
                    isPlatformBuildRunning(build[platform])))));
};
export const isBuildRunning = (build) => {
    if (!build) {
        return false;
    }
    return (!['cancelled', 'succeeded'].includes(build.status) &&
        ['linux', 'mac', 'windows'].some((platform) => isPlatformBuildRunning(build[platform])));
};
export const isBuildCancellable = (build) => hasBuildKickedOff(build) && isBuildRunning(build);
